import React from 'react'
import type { TextInputProps } from '../Text/TextInput'
import { TextInput } from '../Text/TextInput'
export type PhoneNumberInputProps = TextInputProps

export const PhoneNumberInput = ({ placeholder, ...props }: PhoneNumberInputProps) => {
  placeholder = placeholder ?? 'e.g +1 213-456-7890 ext. 123'
  return <TextInput {...props} type="tel" placeholder={placeholder} />
}
